import { ComponentProps, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import map from 'lodash/map';

import { FormSelectField } from '@sbv-clients/ui-forms';

import {
  useAppendAllOption,
  withSanitiseFilterIdValue,
} from '../filter/util/use-append-all-option';
import { useEmployeesGetByDepartmentAndPosition } from '../service/hr';

type EmployeesFieldProps = ComponentProps<typeof FormSelectField> & {
  withAllOption?: boolean;
  facilityId?: number;
};
export const EmployeesFormField = ({
  withAllOption,
  facilityId,
  ...props
}: EmployeesFieldProps) => {
  const { watch } = useFormContext();
  const [departmentId, positionId] = watch(['departmentId', 'positionId']);

  const { data: employees = [] } = useEmployeesGetByDepartmentAndPosition({
    facilityId,
    departmentId,
    positionId: withSanitiseFilterIdValue(positionId),
  });

  const options = useMemo(() => {
    return map(employees, (item) => ({
      id: String(item.employeeId),
      label: item.fullName,
      value: item.employeeId || 0,
    }));
  }, [employees]);

  useAppendAllOption(options, withAllOption);

  return (
    <FormSelectField
      size="small"
      {...props}
      label="Employee"
      options={options}
    />
  );
};
